import { render, staticRenderFns } from "./PlatformCreator.vue?vue&type=template&id=689407c5&"
import script from "./PlatformCreator.vue?vue&type=script&lang=js&"
export * from "./PlatformCreator.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCreator.vue?vue&type=style&index=0&id=689407c5&prod&lang=scss&"
import style1 from "./PlatformCreator.vue?vue&type=style&index=1&id=689407c5&prod&lang=scss&"
import style2 from "./PlatformCreator.vue?vue&type=style&index=2&id=689407c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports